import { t } from "@redotech/redo-i18n";
import { Condition as ModelCondition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import * as React from "react";
import { ConditionType } from "../return-flow/condition";
import { RuleTypeDetailsProps } from "./multiple-actions";

export type ReceivedAtEmailState = string[];

export const RECEIVED_AT_EMAIL = (
  Details: React.ComponentType<RuleTypeDetailsProps<ReceivedAtEmailState>>,
): ConditionType<ReceivedAtEmailState, ModelCondition.ReceivedAtEmail> => ({
  name: CONDITION_NAMES[ModelCondition.RECEIVED_AT_EMAIL],
  description() {
    return t("Which address the email arrived at");
  },
  Details(props: RuleTypeDetailsProps<ReceivedAtEmailState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return model.emails;
  },
  toModel(state) {
    return { type: ModelCondition.RECEIVED_AT_EMAIL, emails: state };
  },
  valid(state) {
    return !state.includes("No email addresses configured");
  },
});
